export function attachStatusInfo() {
    const icon = document.getElementById('status-info-icon');
    const popup = document.getElementById('status-info-popup');
    if (!icon || !popup) {
        return;
    }

    icon.addEventListener('click', (e) => {
        e.stopPropagation();
        const isOpen = popup.style.display === 'block';
        if (isOpen) {
            popup.style.display = 'none';
        } else {
            const rect = icon.getBoundingClientRect();
            popup.style.top = `${rect.bottom + window.scrollY - 4}px`;
            popup.style.left = `${rect.left + window.scrollX}px`;
            popup.style.display = 'block';
        }
    })

    document.addEventListener('click', (e) => {
        if (!icon.contains(e.target) && !popup.contains(e.target)) {
            popup.style.display = 'none';
        }
    });
}

/**
 * Makes badges with data-badge-info clickable.
 * Tapping/clicking shows a tooltip with the badge description.
 */
export function attachBadgeTooltips() {
    // Create a single shared tooltip element
    var tooltip = document.createElement('div');
    tooltip.className = 'badge-tooltip';
    tooltip.style.display = 'none';
    document.body.appendChild(tooltip);

    // Delegate clicks on any badge with data-badge-info
    document.addEventListener('click', function(e) {
        var badge = e.target.closest('[data-badge-info]');

        if (!badge) {
            tooltip.style.display = 'none';
            return;
        }

        e.stopPropagation();

        var info = badge.getAttribute('data-badge-info');
        if (!info) return;

        // Toggle if clicking the same badge
        if (tooltip.style.display === 'block' && tooltip._activeBadge === badge) {
            tooltip.style.display = 'none';
            tooltip._activeBadge = null;
            return;
        }

        tooltip.textContent = info;
        tooltip._activeBadge = badge;

        // Position below the badge
        var rect = badge.getBoundingClientRect();
        tooltip.style.display = 'block';
        var tooltipWidth = tooltip.offsetWidth;
        var left = rect.left + window.scrollX + (rect.width / 2) - (tooltipWidth / 2);

        // Keep within viewport
        if (left < 8) left = 8;
        if (left + tooltipWidth > window.innerWidth - 8) {
            left = window.innerWidth - tooltipWidth - 8;
        }

        tooltip.style.top = (rect.bottom + window.scrollY + 6) + 'px';
        tooltip.style.left = left + 'px';
    });
}
